import { render } from "./GraphQuickPanel.vue?vue&type=template&id=30c127bd"
import script from "./GraphQuickPanel.vue?vue&type=script&lang=js"
export * from "./GraphQuickPanel.vue?vue&type=script&lang=js"

import "./GraphQuickPanel.vue?vue&type=style&index=0&id=30c127bd&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/graph/GraphQuickPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30c127bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30c127bd', __exports__)) {
    api.reload('30c127bd', __exports__)
  }
  
  module.hot.accept("./GraphQuickPanel.vue?vue&type=template&id=30c127bd", () => {
    api.rerender('30c127bd', render)
  })

}


export default __exports__